import React, { useState, useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import Login from "./login/login";
import CaiLogin from "./login/caiLogin";
import Home from "./home/home";
import Context from "./context/context";
import ContextCopy from "./context-copy/context";
import { MsalProvider } from "@azure/msal-react";
import ProtectedRoute from "./protectedRoute";
import { Planogram } from "./planogram/planogram";
import ImageViewerMain from "./ImageViewer/ImageViewerMain";
import AuditIdCard from "./ImageViewer/MobileView/SelectedSessionAudit";
import { useSelector } from "react-redux";
import Annotator from "./Annotator/annotator";
import { socket } from "./socket";
import { useMsal } from "@azure/msal-react";
import ImageViewer from "./ImageViewer/ImageViewerLikeContext/ImageViewer";
import GenerateThumbnail from "./Annotator/generateThumbnails";
import PhoneSdk from "./PhoneSdk/PhoneSdk";
import PrivacyPolicy from "./PrivacyAndPolicy/PrivacyPolicy";
import MotorInsurance from "./MotorInsurance/MotorInsurance";
import MotorInsuranceCopy from "./MotorInsurance-copy/MotorInsurance";
import AnnotationEditor from "./MotorInsurance/annotator/annotator";
import ProcessedResult from "./download-pdf/ProcessedResult"
import Analysis from "./analysis/analysis"

function App({ msalInstance }) {
	const { accounts } = useMsal();
	const userAccount = accounts[0];

	console.log("Logged in user", userAccount);
	useEffect(() => {
		console.log("socket in app.js", socket);
		socket.on("connect", () => {
			console.log("connected");
		});
	}, []);

	const [activeComponent, setActiveComponent] = useState("context");
	const { activeProject } = useSelector((state) => state.imageViewerStore);
	const navigate = useNavigate();

	const toggleComponent = (componentName) => {
		setActiveComponent(componentName);
		if (componentName === "imgViewerTree") {
			navigate("/imageViewerContext");
		} else if (
			componentName !== "imgViewerTree" &&
			activeProject === "thailand-live"
		) {
			navigate("/imageViewer/thailand-live");
		} else if (
			componentName !== "imgViewerTree" &&
			activeProject === "india-live"
		) {
			navigate("/imageViewer/india-live");
		} else if (componentName !== "imgViewerTree") {
			navigate("/imageViewer/india-live");
		}
	};

	return (
		<MsalProvider instance={msalInstance}>
			<Routes>
				<Route path="/" element={<CaiLogin />} />
				<Route path="/context-test" element={<Context />} />
				<Route
					path="/home"
					element={
						<MotorInsurance />
					}
				>
				</Route>
				{/* <Route
					path="/planogram"
					element={
						<ProtectedRoute>
							<Planogram />
						</ProtectedRoute>
					}
				></Route>
				<Route
					path="/phoneSdk"
					element={
						<ProtectedRoute>
							<PhoneSdk />
						</ProtectedRoute>
					}
				></Route>
				<Route
					path="/iaa"
					element={
						<ProtectedRoute>
							<Context />
						</ProtectedRoute>
					}
				></Route>
				<Route
					path="/mi"
					element={
						// <ProtectedRoute>
						<MotorInsurance />
						// </ProtectedRoute>
					}
				></Route>
				<Route
					path="/analyze"
					element={
						// <ProtectedRoute>
						<Analysis />
						// </ProtectedRoute>
					}
				></Route> */}
				<Route
					path="/part-details"
					element={
						// <ProtectedRoute>
						<MotorInsuranceCopy />
						// </ProtectedRoute>
					}
				></Route>
				<Route
					path="/download-pdf"
					element={
						<ProcessedResult />
					}
				></Route>
				{/* <Route
					path="/imageViewer/thailand-live"
					element={
						<ProtectedRoute>
							<ImageViewerMain toggleComponent={toggleComponent} />
						</ProtectedRoute>
					}
				></Route>
				<Route
					path="/imageViewer/india-live"
					element={
						<ProtectedRoute>
							<ImageViewerMain toggleComponent={toggleComponent} />
						</ProtectedRoute>
					}
				></Route> */}
				<Route
					path="/audit"
					element={
						<ProtectedRoute>
							<AuditIdCard />
						</ProtectedRoute>
					}
				></Route>
				<Route
					path="/annotator"
					element={
						<ProtectedRoute>
							<Annotator />
						</ProtectedRoute>
					}
				></Route>
				<Route
					path="/image-editor"
					element={
						// <ProtectedRoute>
						<AnnotationEditor />
						// </ProtectedRoute>
					}
				></Route>
				<Route
					path="/imageViewerContext"
					element={
						<ProtectedRoute>
							<ImageViewer toggleComponent={toggleComponent} />
						</ProtectedRoute>
					}
				></Route>
				<Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
			</Routes>
		</MsalProvider>
	);
}

export default App;
